export enum ESubmitFormStatusWithGtm {
  success = 'success',
  unsuccess = 'err',
}
